import { IFilter } from "../models/filters/filter";
import { ISamplingEventFilter } from "../models/filters/samplingEventFilter";
import _o2sService from "./_o2sServices";
import { API_CENTRE } from "./config";

export default class SamplingEventServices extends _o2sService
{
    protected static override mainUrl:string = API_CENTRE + "/api/v1/samplingevents";

    protected static override getUrlFilter<F extends ISamplingEventFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null) 
        {
            
        }
        return url;
    }
}